import { getPublishedPosts, postNumberByDate } from "../../blog";
import { useLanguage } from "../../LanguageContext";
import { formatDate } from "../../lib/format";
import FeaturedIndex from "./FeaturedIndex";
import SectionTitle from "./SectionTitle";

export default function BlogSection() {
	const { text, lang } = useLanguage();
	const posts = getPublishedPosts(lang);

	return (
		<section className="home-section" aria-labelledby="blog-title">
			<SectionTitle
				id="blog"
				kicker={text.blog.kicker}
				title={text.blog.title}
				titleId="blog-title"
				action={{ to: "/blog", label: text.blog.readArchive }}
			/>
			<FeaturedIndex
				empty={text.blog.empty}
				items={posts.slice(0, 5).map((post) => ({
					id: post.slug,
					href: `/blog/${post.slug}`,
					title: post.title,
					excerpt: post.excerpt,
					cover: post.cover,
					number: postNumberByDate(posts, post.slug),
					eyebrow: text.blog.latest,
					aside: formatDate(post.date, lang),
					dateTime: post.date,
					cta: text.blog.readArticle,
				}))}
			/>
		</section>
	);
}
